<template>
  <v-chart
    v-if="rerender"
    :options="chartOptions"
    autoresize
    class="age-group-chart"
  />
</template>

<script>
import ECharts from "vue-echarts"; // Import ECharts wrapper for Vue
import "echarts/lib/chart/bar"; // Ensure bar chart module is included
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";

export default {
  components: {
    "v-chart": ECharts,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    chartOptions() {
      const barColors = ["#4286f4"];

      const ageGroups = [
        "0 - 14",
        "15 - 24",
        "25 - 34",
        "35 - 44",
        "45 - 54",
        "55 - 64",
        "65+",
      ];

      let ageGroupCounts = ageGroups.reduce((acc, group) => {
        acc[group] = 0;
        return acc;
      }, {});

      this.chartData.forEach((item) => {
        if (
          Object.prototype.hasOwnProperty.call(ageGroupCounts, item.ageGroup)
        ) {
          ageGroupCounts[item.ageGroup]++;
        }
      });

      let seriesData = ageGroups.map((group) => ageGroupCounts[group]);
      let maxValue = Math.max(...seriesData);
      let boundaryGapMax = Math.ceil(maxValue + maxValue * 0.2);

      if (maxValue < 100) {
        boundaryGapMax = 0.3;
      } else if (maxValue >= 100 && maxValue < 500) {
        boundaryGapMax = 1.5;
      } else if (maxValue >= 500 && maxValue < 1000) {
        boundaryGapMax = 7;
      } else if (maxValue >= 1000 && maxValue < 5000) {
        boundaryGapMax = 30;
      } else {
        boundaryGapMax = 80;
      }

      //console.log("boundaryapMax", boundaryGapMax, maxValue);

      return {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["Patients by Age Group"], // This should match the series name
          itemStyle: {
            color: barColors[0], // Set the legend color to match the bar color
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, boundaryGapMax],
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: "#333",
            fontWeight: "normal",
            fontSize: 12,
            align: "center", // For y-axis this could be 'right'
            verticalAlign: "middle", // For x-axis, typically not needed
            margin: 10,
            rotate: 0,
            formatter: function (value) {
              let val = Number(value);
              return val % 1 !== 0 ? "" : value;
            },
          },
          axisTick: { show: false },
        },
        yAxis: {
          type: "category",
          data: ageGroups,
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: "#333",
            fontWeight: "normal",
            fontSize: 12,
            verticalAlign: "middle", // For x-axis, typically not needed
            margin: 10,
            rotate: 0,
          },
          axisTick: { show: false }, // Hide y-axis ticks
        },
        series: [
          {
            name: "Patients by Age Group",
            type: "bar",
            data: seriesData,
            itemStyle: {
              color: (params) => {
                return barColors[params.dataIndex % barColors.length];
              },
            },
          },
        ],
        label: {
          show: true,
          position: "right",
          color: "#000",
        },
      };
    },
  },
  watch: {
    chartData() {
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
    },
  },
  data() {
    return {
      rerender: true,
    };
  },
};
</script>

<style scoped>
.age-group-chart {
  width: 100%;
  height: 100%;
}
</style>
